import { useEffect } from 'react';

import Container from '@/components/@base/container';
import { useGetSearchSuggestion } from '@/components/layout/services/hooks';
import Field from '@/components/shared/components/search/field';
import PreviousSearch from '@/components/shared/components/search/previous-search';
import Result from '@/components/shared/components/search/result';
import Suggests from '@/components/shared/components/search/suggests';
import { useGetSearchWithCategory } from '@/components/shared/services/hooks';

import useCommonModalStore from '@/store/common-modal-store';
import { useSearchStore } from '@/store/search.store';
import { useTourStore } from '@/store/tour.store';

import { DATA_CY_SEARCH_POP_UP } from '@/constant/cypress';

export default function SearchModal() {
  const { data, isPending } = useGetSearchSuggestion();
  const { data: searchResult } = useGetSearchWithCategory({});
  const { params } = useSearchStore();
  const { showTour } = useTourStore();
  const { setShow } = useCommonModalStore();
  useEffect(() => {
    if (showTour) {
      setShow(false);
    }
  }, [showTour]);
  return (
    <Container data-cy={DATA_CY_SEARCH_POP_UP}>
      <Container className='px-5 pt-5'>
        <Field />
      </Container>
      {searchResult && params ? (
        <Result
          demos={searchResult.demos}
          products={searchResult.products}
          categories={searchResult?.categories}
        />
      ) : (
        <>
          <Suggests data={data?.suggestions || []} isLoading={isPending} />
          <PreviousSearch data={data?.previousSearch || []} isLoading={isPending} />
        </>
      )}
    </Container>
  );
}
